import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/** Persists edited content back to an asset's record. Returns the updated asset. */
export async function updateAsset(appConfig, { brandId, assetId, content }, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "update_asset",
    client_id: appConfig.clientId,
    brand_id: brandId,
    asset_id: assetId,
    content,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  const asset = response?.data?.asset;
  if (!asset) {
    throw new Error("Couldn't save this asset");
  }
  return asset;
}